import React from 'react'
import ResponsiveAppBar from './ResponsiveAppBar'
import { useScrollTrigger, Fade, Tooltip, Box, Fab, Toolbar } from '@mui/material';
import { ArrowUpward } from '@mui/icons-material';
import ContactQr from './ContactQr';
interface Props {
    /**
     * Injected by the documentation to work in an iframe.
     * You won't need it on your project.
     */
    window?: () => Window;
    children?: React.ReactElement;
}

function Header(props: Props) {

    function ScrollTop(props: Props) {
        const { children, window } = props;
        const trigger = useScrollTrigger({
            target: window ? window() : undefined,
            disableHysteresis: true,
            threshold: 100,
        });

        const handleClick = (event: React.MouseEvent<HTMLDivElement>) => {
            const anchor = (
                (event.target as HTMLDivElement).ownerDocument || document
            ).querySelector('#back-to-top-anchor');

            if (anchor) {
                anchor.scrollIntoView({
                    block: 'center',
                });
            }
        };

        return (
            <Fade in={trigger}>
                <Tooltip title="Remonter en haut de la page">
                    <Box
                        onClick={handleClick}
                        role="presentation"
                        sx={{ position: 'fixed', bottom: 150, right: 20 }}
                    >
                        {children}
                    </Box>
                </Tooltip>
            </Fade>
        );
    }

    return (
        <div>
            <Toolbar id="back-to-top-anchor" >
                <ResponsiveAppBar />
                <Box  zIndex={1}>
                    <ScrollTop {...props}>
                        <Fab style={{backgroundColor: "white"}} color='inherit' size="small" aria-label="scroll back to top">
                            <ArrowUpward style={{color:"#13367d"}} />
                        </Fab>
                    </ScrollTop>
                </Box>
            </Toolbar>
            <ContactQr />
        </div>
    )
}

export default Header
